module.exports = __webpack_public_path__ + "images/thumb-c95ab58bd40f869cfada892be9430771.jpg";